import * as styles from "@/styles/modules/Grid.module.scss"

interface GridProps {
  className?: string
  children: React.ReactNode
  mobile?: number
  mobileLg?: number
  tablet?: number
  desktop?: number
  rowGap?: number
  columnGap?: number
}

export default function Grid({
  className,
  children,
  mobile,
  mobileLg,
  tablet,
  desktop,
  rowGap,
  columnGap,
}: GridProps) {
  const columnClasses = [className]
  mobile && columnClasses.push(styles[`mobile${mobile}`])
  mobileLg && columnClasses.push(styles[`mobileLg${mobileLg}`])
  tablet && columnClasses.push(styles[`tablet${tablet}`])
  desktop && columnClasses.push(styles[`desktop${desktop}`])

  return (
    <div
      className={`${styles.wrapper} ${columnClasses.join(" ")}`}
      style={{
        gridRowGap: rowGap ? `${rowGap}px` : undefined,
        gridColumnGap: columnGap ? `${columnGap}px` : undefined,
      }}
    >
      {children}
    </div>
  )
}
